<template> 
    <PerfectScrollbar style="padding-top: 0 !important; padding-bottom: 0 !important;" class="AllPwaMobile">

  <div class="blocked" :class="theme" :dir="currentLang==='fa' ? 'rtl' : 'ltr'">
    <div class="card">
      <div class="icon-wrap">
        <VsxIcon iconName="InfoCircle" :size="64" :color="theme==='light' ? '#E53935' : '#FF6E6E'" />
      </div>
      <h2>{{ currentLang==='fa' ? 'حساب شما مسدود شده است' : 'Your account is blocked' }}</h2>
      <p class="desc">
        {{ currentLang==='fa' ? 'برای بررسی و رفع مشکل، یک تیکت برای پشتیبانی ثبت کنید. در این مدت دسترسی شما به بخش‌های اپ محدود است.' : 'Please submit a support ticket so our team can review and restore your access. Your access to app sections is limited during this time.' }}
      </p>

      <div class="actions">
        <button class="btn neutral" @click="refreshStatus" :disabled="checking">
          {{ checking ? (currentLang==='fa'?'در حال بررسی...':'Checking...') : (currentLang==='fa' ? 'بررسی مجدد وضعیت' : 'Check status again') }}
        </button>
        <button class="btn ghost" @click="logout" :disabled="checking">
          {{ currentLang==='fa' ? 'خروج' : 'Logout' }}
        </button>
      </div>

             <div class="tips">
         <div class="tip-title">{{ currentLang==='fa' ? 'راهنما:' : 'Tips:' }}</div>
         <ul>
           <li>{{ currentLang==='fa' ? 'در پیام خود، نام کاربری و توضیح مختصر دلیل احتمالی مسدود شدن را ذکر کنید.' : 'Include your username and a brief description of the situation in your message.' }}</li>
           <li>{{ currentLang==='fa' ? 'اگر قبلاً احراز هویت انجام داده‌اید، وضعیت آن را هم بنویسید.' : 'If you have already completed KYC, mention its status as well.' }}</li>
         </ul>
       </div>

       <div class="tickets-section" v-if="tickets.length > 0">
         <h3>{{ currentLang==='fa' ? 'تیکت‌های قبلی:' : 'Previous tickets:' }}</h3>
         <div class="tickets-list">
                       <div v-for="ticket in tickets" :key="ticket.id" class="ticket-item" @click="openTicketChat(ticket)">
              <div class="ticket-header">
                <span class="ticket-subject">{{ ticket.subject }}</span>
                <span class="ticket-status" :class="getStatusClass(ticket.status)">
                  {{ getStatusText(ticket.status) }}
                </span>
              </div>
              <div class="ticket-date">{{ formatDate(ticket.created_at) }}</div>
            </div>
         </div>
       </div>

      <form class="ticket-form" @submit.prevent="submitTicket">
        <div class="form-item">
          <label>{{ currentLang==='fa' ? 'موضوع' : 'Subject' }}</label>
          <input v-model.trim="subject" type="text" :placeholder="currentLang==='fa'?'مثلاً: درخواست بررسی مسدودی':'e.g. Account block review request'" required />
          <small class="hint" v-if="subject && subject.length<4">{{ currentLang==='fa'?'حداقل ۴ کاراکتر':'At least 4 characters' }}</small>
        </div>
        <div class="form-item">
          <label>{{ currentLang==='fa' ? 'پیام' : 'Message' }}</label>
          <textarea v-model.trim="message" rows="6" :placeholder="currentLang==='fa'?'جزئیات مشکل را بنویسید...':'Describe the issue in detail...'" required />
          <small class="hint" v-if="message && message.length<10">{{ currentLang==='fa'?'حداقل ۱۰ کاراکتر':'At least 10 characters' }}</small>
        </div>
        <div class="form-row">
          <button class="btn" type="submit" :disabled="submitting || subject.length<4 || message.length<10">
            {{ submitting ? (currentLang==='fa'?'در حال ارسال...':'Submitting...') : (currentLang==='fa' ? 'ارسال تیکت' : 'Submit Ticket') }}
          </button>
        </div>
             </form>
     </div>
   </div>

   <!-- Modal for ticket chat -->
   <div v-if="showChatModal" class="chat-modal-overlay" @click="closeChatModal">
     <div class="chat-modal" @click.stop>
       <div class="chat-header">
         <h3>{{ selectedTicket?.subject }}</h3>
         <button class="close-btn" @click="closeChatModal">×</button>
       </div>
       <div class="chat-messages" ref="chatMessages">
         <div v-for="message in chatMessages" :key="message.id" class="message" :class="message.user_id ? 'user-message' : 'admin-message'">
           <div class="message-content">{{ message.message }}</div>
           <div class="message-time">{{ formatTime(message.created_at) }}</div>
         </div>
       </div>
       <div class="chat-input">
         <textarea v-model="newMessage" :placeholder="currentLang==='fa'?'پیام خود را بنویسید...':'Type your message...'" rows="3"></textarea>
         <button class="send-btn" @click="sendMessage" :disabled="!newMessage.trim() || sendingMessage">
           {{ sendingMessage ? (currentLang==='fa'?'در حال ارسال...':'Sending...') : (currentLang==='fa' ? 'ارسال' : 'Send') }}
         </button>
       </div>
     </div>
   </div>
   </PerfectScrollbar>
  
</template>

<script>
import axios from '@/axios';
import { toast } from 'vue3-toastify';
import 'vue3-toastify/dist/index.css';
import { PerfectScrollbar } from 'vue3-perfect-scrollbar'


export default {
  name: 'BlockedUser',
  components: {
    PerfectScrollbar
  },
  data() {
    return {
             subject: '',
       message: '',
       submitting: false,
       checking: false,
       langThemeTimer: null,
       tickets: [],
       showChatModal: false,
       selectedTicket: null,
       chatMessages: [],
       newMessage: '',
       sendingMessage: false,
    };
  },
  computed: {
    currentLang() {
      return this.$store.state.currentLang;
    },
    theme() {
      return this.$store.state.theme;
    }
  },
  mounted() {
     this.fetchTickets();
   },
  beforeUnmount() {
    // No cleanup needed since we removed the timer
  },
  methods: {
    async refreshStatus() {
      try {
        this.checking = true;
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        if (!user || !user.id) return;
        const res = await axios.post('/get-user-profile', { user_id: user.id, language: this.currentLang });
        if (res && res.data && res.data.user) {
          const fresh = res.data.user;
          localStorage.setItem('user', JSON.stringify(fresh));
          if (!fresh.is_blocked) {
            this.$router.replace({ name: 'IndexUser' });
            return;
          }
        }
      } catch(e) {
        // ignore
      } finally {
        this.checking = false;
      }
    },
    async logout() {
      try {
        // پاک کردن داده‌های محلی کاربر
        localStorage.removeItem('user');
        localStorage.removeItem('email');
        localStorage.removeItem('password');
      } finally {
        this.$router.replace({ name: 'LoginUser' });
      }
    },
    async submitTicket() {
      try {
        this.submitting = true;
        const user = JSON.parse(localStorage.getItem('user') || '{}');
        if (!user || !user.id) {
          toast(this.currentLang==='fa'?'ابتدا وارد شوید':'Please login first', { type: 'error' });
          return;
        }
        await axios.post('/create-ticket', {
          user_id: user.id,
          name: user.name || user.username || 'user',
          email: user.email,
          subject: this.subject,
          priority: 2,
          message: this.message,
        });
                 toast(this.currentLang==='fa'?'تیکت ارسال شد':'Ticket submitted', { type: 'success' });
         this.subject = '';
         this.message = '';
         this.fetchTickets(); // Refresh tickets list
      } catch (e) {
        toast(this.currentLang==='fa'?'خطا در ارسال تیکت':'Failed to submit ticket', { type: 'error' });
             } finally {
         this.submitting = false;
       }
     },
     async fetchTickets() {
       try {
         const user = JSON.parse(localStorage.getItem('user') || '{}');
         if (!user || !user.id) return;
         const res = await axios.post('/get-supports', { id: user.id });
         if (res && res.data) {
           this.tickets = res.data;
         }
       } catch (e) {
         // ignore
       }
     },
     getStatusText(status) {
       const statusMap = {
         0: this.currentLang==='fa' ? 'باز' : 'Open',
         1: this.currentLang==='fa' ? 'پاسخ داده شده' : 'Replied',
         2: this.currentLang==='fa' ? 'پاسخ کاربر' : 'User Reply',
         3: this.currentLang==='fa' ? 'بسته' : 'Closed'
       };
       return statusMap[status] || status;
     },
     getStatusClass(status) {
       const classMap = {
         0: 'status-open',
         1: 'status-replied',
         2: 'status-user-reply',
         3: 'status-closed'
       };
       return classMap[status] || 'status-open';
     },
     formatDate(dateString) {
       try {
         return new Date(dateString).toLocaleDateString(this.currentLang==='fa' ? 'fa-IR' : 'en-US');
       } catch {
         return dateString;
       }
     },
     async openTicketChat(ticket) {
       this.selectedTicket = ticket;
       this.showChatModal = true;
       this.chatMessages = [];
       this.newMessage = '';
       await this.fetchChatMessages(ticket.id);
       this.$nextTick(() => {
         this.scrollToBottom();
       });
     },
     closeChatModal() {
       this.showChatModal = false;
       this.selectedTicket = null;
       this.chatMessages = [];
       this.newMessage = '';
     },
           async fetchChatMessages(ticketId) {
        try {
          const user = JSON.parse(localStorage.getItem('user') || '{}');
          const res = await axios.post('/ticket-get', { 
            user_id: user.id,
            ticket: ticketId.toString()
          });
          if (res && res.data && res.data[1]) {
            this.chatMessages = res.data[1];
          }
        } catch (e) {
          console.error('Error fetching chat messages:', e);
        }
      },
           async sendMessage() {
        if (!this.newMessage.trim() || !this.selectedTicket) return;
        
        try {
          this.sendingMessage = true;
          const user = JSON.parse(localStorage.getItem('user') || '{}');
          await axios.post('/ticket-message', {
            user_id: user.id,
            ticket: this.selectedTicket.id.toString(),
            message: this.newMessage.trim()
          });
          
          this.newMessage = '';
          await this.fetchChatMessages(this.selectedTicket.id);
          this.$nextTick(() => {
            this.scrollToBottom();
          });
        } catch (e) {
          toast(this.currentLang==='fa'?'خطا در ارسال پیام':'Error sending message', { type: 'error' });
        } finally {
          this.sendingMessage = false;
        }
      },
     scrollToBottom() {
       if (this.$refs.chatMessages) {
         this.$refs.chatMessages.scrollTop = this.$refs.chatMessages.scrollHeight;
       }
     },
     formatTime(dateString) {
       try {
         return new Date(dateString).toLocaleTimeString(this.currentLang==='fa' ? 'fa-IR' : 'en-US', {
           hour: '2-digit',
           minute: '2-digit'
         });
       } catch {
         return dateString;
       }
     }
  }
};
</script>

<style scoped>
.blocked { display:flex; align-items:center; justify-content:center; padding: 20px; }
.card {background: #ffffff; max-width: 400px; border: 1px solid #e0e0e0; border-radius: 16px; padding: 24px; text-align: center; box-shadow: 0 8px 24px rgba(0,0,0,0.08); }
.icon-wrap { display:flex; align-items:center; justify-content:center; margin-bottom: 12px; }
h2 { margin: 8px 0 6px 0; color: #333333; font-family: "iranyekanB"; font-size: 24px; }
.desc { margin: 0 0 16px 0; color: #666666; }
.actions { display:flex; gap: 8px; justify-content:center; margin: 8px 0 16px 0; }
.btn.neutral { background: #f5f5f5; color: #333333; border: 1px solid #e0e0e0; }
.btn.ghost { background: transparent; color: #666666; border: 1px solid #e0e0e0; }
.tips { text-align: start; margin: 12px 0 16px 0; background: #f5f5f5; border: 1px dashed #e0e0e0; border-radius: 8px; padding: 12px; }
.tip-title { color: #666666; font-size: 12px; margin-bottom: 8px; }
.tips ul { margin: 0; padding-inline-start: 18px; color: #666666; }
.ticket-form { display: grid; gap: 12px; text-align: start; }
.form-item { display:flex; flex-direction: column; gap: 6px; }
.form-item label { color: #666666; font-size: 12px; }
.form-item input, .form-item textarea { background: #f5f5f5; border: 1px solid #e0e0e0; border-radius: 8px; padding: 10px; color: #333333; }
.form-row { display:flex; justify-content:flex-end; }
.btn { background: linear-gradient(45deg, #BB86FC, #03DAC6); color:#fff; border:none; border-radius:8px; padding:10px 12px; cursor:pointer; }
.hint { color: #666666; font-size: 11px; }

/* اضافه کردن استایل‌های گم شده */
.btn.neutral:hover { background: #e0e0e0; }
.btn.ghost:hover { background: #f5f5f5; }
.form-item input:focus, .form-item textarea:focus { outline: none; border-color: #BB86FC; box-shadow: 0 0 0 2px rgba(187, 134, 252, 0.1); }
.btn:disabled { opacity: 0.6; cursor: not-allowed; }
.btn:hover:not(:disabled) { transform: translateY(-1px); box-shadow: 0 4px 8px rgba(0,0,0,0.1); }

/* تیکت‌ها استایل */
.tickets-section { margin: 16px 0; text-align: start; }
.tickets-section h3 { color: #333333; font-size: 18px; margin-bottom: 12px; }
.tickets-list { display: grid; gap: 8px; }
.ticket-item { background: #f9f9f9; border: 1px solid #e0e0e0; border-radius: 8px; padding: 12px; }
.ticket-header { display: flex; justify-content: space-between; align-items: center; margin-bottom: 4px; }
.ticket-subject { color: #333333; font-weight: 500; }
.ticket-status { font-size: 11px; padding: 2px 6px; border-radius: 4px; }
.status-open { background: #fff3cd; color: #856404; }
.status-replied { background: #d1ecf1; color: #0c5460; }
.status-user-reply { background: #d4edda; color: #155724; }
.status-closed { background: #f8d7da; color: #721c24; }
.ticket-date { color: #666666; font-size: 11px; }
.ticket-item { cursor: pointer; transition: background-color 0.2s; }
.ticket-item:hover { background: #f0f0f0; }

/* Modal styles */
.chat-modal-overlay { position: fixed; top: 0; left: 0; right: 0; bottom: 0; background: rgba(0,0,0,0.5); display: flex; align-items: center; justify-content: center; z-index: 1000; }
.chat-modal { background: #ffffff; border-radius: 12px; width: 90%; max-width: 500px; max-height: 80vh; display: flex; flex-direction: column; }
.chat-header { display: flex; justify-content: space-between; align-items: center; padding: 16px; border-bottom: 1px solid #e0e0e0; }
.chat-header h3 { margin: 0; color: #333333; font-size: 18px; }
.close-btn { background: none; border: none; font-size: 24px; color: #666666; cursor: pointer; padding: 0; width: 30px; height: 30px; display: flex; align-items: center; justify-content: center; }
.close-btn:hover { color: #333333; }
.chat-messages { flex: 1; padding: 16px; overflow-y: auto; max-height: 300px; display: flex; flex-direction: column; gap: 12px; }
.message { display: flex; flex-direction: column; max-width: 80%; }
.user-message { align-self: flex-end; }
.admin-message { align-self: flex-start; }
.message-content { padding: 8px 12px; border-radius: 12px; word-wrap: break-word; }
.user-message .message-content { background: linear-gradient(45deg, #BB86FC, #03DAC6); color: #ffffff; }
.admin-message .message-content { background: #f5f5f5; color: #333333; }
.message-time { font-size: 10px; color: #666666; margin-top: 4px; text-align: center; }
.chat-input { padding: 16px; border-top: 1px solid #e0e0e0; display: flex; gap: 8px; }
.chat-input textarea { flex: 1; border: 1px solid #e0e0e0; border-radius: 8px; padding: 8px; resize: none; font-family: inherit; }
.chat-input textarea:focus { outline: none; border-color: #BB86FC; }
.send-btn { background: linear-gradient(45deg, #BB86FC, #03DAC6); color: #ffffff; border: none; border-radius: 8px; padding: 8px 16px; cursor: pointer; font-size: 14px; }
.send-btn:disabled { opacity: 0.6; cursor: not-allowed; }
.send-btn:hover:not(:disabled) { transform: translateY(-1px); }
</style>


